export function generateCsvData(csvData) {
  const csvColumnNames = csvData[0] ? Object.keys(csvData[0]) : [];

  return csvData
    .sort((a, b) =>
      a.field_name && b.field_name
        ? a.field_name.localeCompare(b.field_name)
        : a - b,
    )
    .reduce(
      (doc, row) => {
        const values = csvColumnNames.map((cn) => {
          if (typeof row[cn] === 'string') {
            return `"${row[cn].replace(/"/g, "'")}"`;
          }

          return row[cn];
        });

        return `${doc}${values.join(',')}\n`;
      },
      `${csvColumnNames.join(',')}\n`,
    );
}

export function generateCsvDownload(csvData, filename = 'download.csv') {
  const csvOutput = generateCsvData(csvData);
  const blob = new Blob([csvOutput], { type: 'text/csv;charset=utf-8' });
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const a = window.document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.setAttribute('download', filename);
    a.click();
  }
}
